import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface FormColorPickerProps {
  label: string;
  value: string;
  onChange: (color: string) => void;
  error?: string | undefined;
  hint?: string;
  presets?: string[];
  className?: string;
  fullWidth?: boolean;
}

const DEFAULT_PRESETS = [
  '#4338CA', // indigo-700
  '#6366F1', // indigo-500
  '#10B981', // emerald-500
  '#E11D48', // rose-600
  '#F59E0B', // amber-500
  '#0EA5E9', // sky-500
  '#8B5CF6', // violet-500
  '#EC4899', // pink-500
  '#14B8A6', // teal-500
  '#71717A', // zinc-500
];

export function FormColorPicker({
  label,
  value,
  onChange,
  error,
  hint,
  presets = DEFAULT_PRESETS,
  className,
  fullWidth,
}: FormColorPickerProps): JSX.Element {
  return (
    <div className={cn('space-y-1.5', fullWidth && 'sm:col-span-2', className)}>
      <Label>{label}</Label>
      <div className="flex items-center gap-2">
        <input
          type="color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-invalid={!!error}
          className="h-9 w-16 cursor-pointer rounded-md border border-input bg-background"
        />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="h-9 w-28 rounded-md border border-input bg-background px-2 font-mono text-xs"
          maxLength={7}
        />
        <div className="flex flex-wrap gap-1">
          {presets.map((p) => (
            <button
              key={p}
              type="button"
              onClick={() => onChange(p)}
              className={cn(
                'h-6 w-6 rounded-md border border-border ring-offset-background transition-transform',
                'hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1',
                value.toLowerCase() === p.toLowerCase() && 'ring-2 ring-foreground ring-offset-1',
              )}
              style={{ backgroundColor: p }}
              aria-label={`Choisir ${p}`}
            />
          ))}
        </div>
      </div>
      {error && <p className="text-xs text-destructive">{error}</p>}
      {!error && hint && <p className="text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}
